import { lazy } from 'react';

const ManagerPageFacturedConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/manager/factured',
			component: lazy(() => import('./ManagerContainerFactured'))
		}
	]
};

export default ManagerPageFacturedConfig;